import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import { diagnosticFetch } from './diagnostics';

export function supportId() {
  const bytes = new Uint8Array(16);
  window.crypto.getRandomValues(bytes);
  return Array.from(bytes, value => value.toString(16).padStart(2, '0')).join('');
}

export async function supportRequest(body, expectedUser = firebase.auth().currentUser) {
  if (!expectedUser || firebase.auth().currentUser !== expectedUser) {
    throw Object.assign(new Error('Please sign in to your shop again.'), { code: 'AUTH_REQUIRED' });
  }
  const token = await expectedUser.getIdToken();
  if (firebase.auth().currentUser !== expectedUser) throw Object.assign(new Error('The shop session changed.'), { code: 'SESSION_CHANGED' });
  const base = String(process.env.VUE_APP_FUNCTIONS_URL || '').replace(/\/+$/, '');
  if (!base) throw new Error('Support is not configured. Please email support@app-xprofit.com.');
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), 65000);
  try {
    const response = await diagnosticFetch(`${base}/support-chat`, {
      method: 'POST', cache: 'no-store', signal: controller.signal,
      headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    });
    const data = await response.json();
    if (firebase.auth().currentUser !== expectedUser) throw Object.assign(new Error('The shop session changed.'), { code: 'SESSION_CHANGED' });
    if (!response.ok) throw Object.assign(new Error(data.error || 'Support is temporarily unavailable.'), { code: data.code, status: response.status });
    return { conversation: data.conversation, aiEnabled: data.aiEnabled === true };
  } finally {
    clearTimeout(timeout);
  }
}
